export default "__VITE_ASSET__VUuExXwz__"